import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const links = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Case Studies', path: '/case-studies' },
  ];

  return (
    <header className="bg-white/90 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 bg-navy-900 rounded flex items-center justify-center">
              <span className="text-gold-500 font-serif font-bold text-xl">K</span>
            </div>
            <span className="font-serif font-bold text-xl text-navy-900 tracking-tight">The Kajidori Collective</span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {links.map((link) => (
              <Link 
                key={link.name} 
                to={link.path}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === link.path ? 'text-gold-600' : 'text-slate-600 hover:text-navy-900'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="h-6 w-px bg-slate-300 mx-2"></div>
            <Link to="/portal/login" className="flex items-center gap-2 text-sm font-medium text-navy-900 hover:text-gold-600 transition-colors">
              <SafeIcon name="Lock" className="w-4 h-4" />
              Client Portal
            </Link>
            <Link to="/contact" className="bg-navy-900 text-white px-5 py-2.5 rounded text-sm font-medium hover:bg-navy-800 transition-colors">
              Work With Us
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setIsOpen(!isOpen)}>
            <SafeIcon name={isOpen ? "X" : "Menu"} className="w-6 h-6" />
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <motion.div 
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden bg-white border-b border-slate-200 px-4 pt-2 pb-6 space-y-4"
        >
          {links.map((link) => (
             <Link 
               key={link.name} 
               to={link.path}
               onClick={() => setIsOpen(false)}
               className="block text-base font-medium text-slate-700 py-2 border-b border-slate-100"
             >
               {link.name}
             </Link>
          ))}
          <Link to="/portal/login" onClick={() => setIsOpen(false)} className="block text-base font-medium text-navy-900 py-2">
            Client Portal Login
          </Link>
          <Link to="/contact" onClick={() => setIsOpen(false)} className="block w-full text-center bg-navy-900 text-white px-5 py-3 rounded font-medium mt-4">
            Work With Us
          </Link>
        </motion.div>
      )}
    </header>
  );
};

export default Navbar;